export const unsubscribe = async(token) => {
    // For Local Dev Testing Purposes Only.
    // const functionUrl = `http://localhost:5001/wellbeing-49fed/us-central1/unsubscribe?token=${token}`;
    const functionUrl = `https://us-central1-wellbeing-49fed.cloudfunctions.net/unsubscribe?token=${token}`;
    const response = await fetch(functionUrl, { method: 'POST' });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Failed to unsubscribe');
    }

    return response.text();
};
